import PrimaryButton from "../buttons/PrimaryButton";
import Icon1 from "../icons/Icon";
import SecondaryButton from "../buttons/SecondaryButton";
import UploadInvoice from "../api/upload/UploadInvoice";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import { useSnackbar } from "notistack";
import { useTheme } from "@mui/material";
import SmallSpinner from "../loading/SmallSpinner";
import { useNavigate } from "react-router-dom";
import Space from "../layout/Space";
import { useEffect, useState } from "react";

import { useAppContext } from "../config/AppContext";
import deleteDocApi from "../api/database/deleteDocApi";
import { addActivityLog } from "../config/OnlineStatus";

import getTemporaryUrlV2 from "../api/getTemporaryUrlV2";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import { isFolderAdmin, isFolderClient } from "../pages/folder_pages/FolderHelpers";
import { getDocDataByRef, getFlutterTime, getDocDataById } from "../models/DataFunctions";
import createDocApi from "../api/database/createDocApi";
import { Timestamp, doc } from "firebase/firestore";
import { format, addDays } from "date-fns";
import { queryCollectionAlgolia } from "../models/AlgoliaFunctions";
import { db } from "../config/FirebaseConfig";

const ReglementFolderDevis = ({
  orgData,
  userData,
  folderData,

  handleFetchData,

  loadingTransfer,
  setLoadingTransfer,
  transferFiles,

  dropped_exists,
  navigateWorkspace,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [loadingInvoice, setLoadingInvoice] = useState(false);
  const [loadingCreateDevis, setLoadingCreateDevis] = useState(false);
  const [devis, setDevis] = useState([]);
  const [showLinkSearch, setShowLinkSearch] = useState(false);
  const [linkSearchValue, setLinkSearchValue] = useState("");
  const [linkResults, setLinkResults] = useState([]);
  const [loadingLink, setLoadingLink] = useState(false);
  const [showCreateConfirm, setShowCreateConfirm] = useState(false);

  const handleFetchDevisObjects = async () => {
    let devis = [];
    for (const invoice of folderData.invoices || []) {
      if (invoice.ref) {
        let devisData = (await getDocDataByRef(invoice.ref)) || null;
        devis.push(devisData);
      }
    }
    setDevis(devis);
  };

  const handleTransferFiles = async (docId) => {
    setLoadingTransfer(docId);
    await transferFiles(docId);
    setLoadingTransfer(null);
  };

  const handleCreateDevisFromFolder = async () => {
    try {
      setLoadingCreateDevis(true);
      const master = orgData;
      const regInfos = folderData.reglement?.infos || {};

      const body = {
        org_id: master.id,
        creation_date: getFlutterTime(),
        client_id: folderData.client_type !== "particulier" ? folderData.client_id : null,
        state: "draft",
        nom: regInfos.name || folderData.nom || "",
        first_name: "",
        logo_url: master.logo || "https://i.ibb.co/CWHxrfX/Hexagone-UXLogo3-LOW-1024.png",
        champs: [],
        forms: [],
        master_name: master?.name,
        master_adresse: master.infos?.adresse || "",
        master_postal: master.infos?.postal || "",
        master_ville: master.infos?.ville || "",
        siret: master.infos?.siret || "",
        num_tva: master.infos?.num_tva || "",
        phone: master.infos?.phone || "",
        email: master.infos?.email || "",
        num_devis: "DEV" + Math.floor(Math.random() * 1000000),
        date: format(new Date(), "dd/MM/yyyy"),
        date_validite: format(addDays(new Date(), 30), "dd/MM/yyyy"),
        nom_client: regInfos.name || folderData.nom || "",
        civilite_client: "",
        adresse_client: regInfos.address || folderData.adresse || "",
        postal_client: regInfos.postal || folderData.postal || "",
        ville_client: regInfos.city || folderData.ville || "",
        adresse_projet: folderData.adresse || "",
        postal_projet: folderData.postal || "",
        ville_projet: folderData.ville || "",
        banque: master.infos?.banque || "",
        iban: master.infos?.iban || "",
        bic: master.infos?.bic || "",
        prix_tot_ttc: 0,
        politique_annulation: master.infos?.politique_annulation || "",
        conditions_generales_vente: master.infos?.conditions_generales_vente || "",
        conditions_reglement: master.infos?.conditions_reglement || "",
        politique_echec: master.infos?.politique_echec || "",
        email_client: regInfos.email || "",
        tel_client: regInfos.phone || "",
        articles: [],
        surface: 0,
        surfaces: [],
        nombre_maisons: 1,
        base_ht: 0,
        supplement: 0,
        total_remise: 0,
        total_ht: 0,
        tva: 0,
        total_ttc: 0,
        marque: folderData.marque || "Particulier",
        client_type: folderData.client_type || "particulier",
        history_events: [{ date: Timestamp.now(), name: "Création du brouillon depuis dossier" }],
        author: orgData?.type,
        structure_type: "maison_individuelle",
        folder_ref: folderData.ref,
      };

      const new_devis = await createDocApi("devis", body, prefix);
      if (!new_devis || !new_devis.id) {
        handleClickVariant("Erreur lors de la création du devis", "error");
        setLoadingCreateDevis(false);
        return;
      }

      await updateDocDataFieldApi(new_devis.ref, "author", orgData?.type, prefix);

      // Link devis to folder
      const currentInvoices = folderData.invoices || [];
      await updateDocDataFieldApi(
        folderData.ref,
        "invoices",
        [...currentInvoices, { ref: new_devis.ref, file: new_devis.file || { id: "", name: "" } }],
        prefix
      );

      handleClickVariant("Brouillon créé depuis le dossier", "success");
      navigateWorkspace("/newinvoicefromdraft/" + new_devis.id);
    } catch (error) {
      console.error("Error creating devis from folder:", error);
      handleClickVariant("Erreur lors de la création du devis", "error");
    } finally {
      setLoadingCreateDevis(false);
    }
  };

  const handleSearchDevis = async (value) => {
    setLinkSearchValue(value);
    if (value.length < 2) { setLinkResults([]); return; }
    const results = await queryCollectionAlgolia(
      "devis",
      [{ field: "org_id", operator: "==", value: orgData.id }],
      value,
      10
    );
    setLinkResults(results || []);
  };

  const handleLinkDevis = async (devisResult) => {
    try {
      setLoadingLink(true);
      const devisDoc = await getDocDataById("devis", devisResult.objectID);
      if (!devisDoc) {
        handleClickVariant("Devis introuvable", "error");
        return;
      }
      const devisRef = doc(db, "devis", devisResult.objectID);

      // Add to folder invoices
      const currentInvoices = folderData.invoices || [];
      const alreadyLinked = currentInvoices.some((inv) => inv.ref?.id === devisResult.objectID);
      if (alreadyLinked) {
        handleClickVariant("Ce devis est déjà lié au dossier", "warning");
        return;
      }
      await updateDocDataFieldApi(
        folderData.ref,
        "invoices",
        [...currentInvoices, { ref: devisRef, file: devisDoc.file || { id: "", name: devisDoc.num_devis || "Devis" } }],
        prefix
      );

      // Link folder back to devis
      await updateDocDataFieldApi(devisRef, "folder_ref", folderData.ref, prefix);

      handleClickVariant("Devis lié au dossier", "success");
      setShowLinkSearch(false);
      setLinkSearchValue("");
      setLinkResults([]);
      handleFetchData();
    } catch (error) {
      console.error("Error linking devis:", error);
      handleClickVariant("Erreur lors du lien", "error");
    } finally {
      setLoadingLink(false);
    }
  };

  const handleLoadInvoice = async (invoice) => {
    if (invoice.file.id) {
      setLoadingInvoice(invoice.file.id);
      const token = await getOrRefreshFirebaseToken();
      let refreshed_url = await getTemporaryUrlV2(
        invoice.file.id,
        token,
        prefix
      );
      if (refreshed_url) {
        window.open(refreshed_url, "_blank");
      } else {
        handleClickVariant("Impossible de charger le fichier", "error");
      }
      setLoadingInvoice(false);
    }
  };

  const handleRemoveInvoice = async (invoice) => {
    setLoadingInvoice(invoice.file.id);
    let new_invoices = folderData.invoices.filter(
      (inv) => inv.file?.id !== invoice.file?.id
    );
    await updateDocDataFieldApi(
      folderData.ref,
      "invoices",
      new_invoices,
      prefix
    );
    await addActivityLog(
      "Devis supprimé",
      folderData.ref,
      orgData.id,
      userData.id,
      "invoice_deleted",
      prefix
    );

    handleFetchData();
    handleClickVariant("Devis supprimé", "success");
    setLoadingInvoice(false);
  };

  useEffect(() => {
    handleFetchDevisObjects();
  }, [folderData]);

  return (
    <div className="w-full h-fit flex flex-col p-2 gap-1">
      <div className="flex flex-col gap-2 text-h3 text-black ">
        <div className="flex flex-row justify-between items-center">
          Devis{" "}
          <div className="flex flex-row gap-1 items-center">
            {isFolderAdmin(orgData, folderData) && (
              <>
                <div
                  className="text-h5 cursor-pointer hover:bg-indigo-100 bg-indigo-50 text-indigo-600 border-1 border-indigo-200 rounded-md px-2 py-0.5 flex flex-row gap-1 items-center"
                  onClick={() => { setShowCreateConfirm(true); setShowLinkSearch(false); }}
                >
                  <Icon1 icon_name="add" size={12} fill="indigo" />
                  Créer
                </div>
                <div
                  className="text-h5 cursor-pointer hover:bg-amber-100 bg-amber-50 text-amber-700 border-1 border-amber-200 rounded-md px-2 py-0.5 flex flex-row gap-1 items-center"
                  onClick={() => setShowLinkSearch(!showLinkSearch)}
                >
                  <Icon1 icon_name="linked_file" size={12} fill="orange" />
                  Lier
                </div>
              </>
            )}
            <div className="w-8 h-fit">
              <UploadInvoice
                folderId={folderData.id}
                onUpdate={handleFetchData}
                prefix={prefix}
              ></UploadInvoice>
            </div>
          </div>
        </div>
        {showCreateConfirm && (
          <div className="flex flex-col gap-2 p-2 bg-indigo-50 border-1 border-indigo-200 rounded-md">
            <div className="text-h4 text-shadow_50">
              Créer un brouillon de devis pré-rempli avec les informations du dossier ?
            </div>
            <div className="flex flex-row gap-2">
              <PrimaryButton
                onClick={() => {
                  setShowCreateConfirm(false);
                  handleCreateDevisFromFolder();
                }}
                disabled={loadingCreateDevis}
              >
                {loadingCreateDevis ? (
                  <SmallSpinner size={14} margin={0} />
                ) : (
                  "Confirmer"
                )}
              </PrimaryButton>
              <SecondaryButton onClick={() => setShowCreateConfirm(false)}>
                Annuler
              </SecondaryButton>
            </div>
          </div>
        )}
        {showLinkSearch && (
          <div className="flex flex-col gap-1 p-2 bg-amber-50 border-1 border-amber-200 rounded-md">
            <input
              type="text"
              className="w-full text-h4 px-2 py-1 border-1 border-shadow_25 rounded-md outline-none focus:border-amber-400"
              placeholder="Rechercher un devis (nom, numéro...)"
              value={linkSearchValue}
              onChange={(e) => handleSearchDevis(e.target.value)}
              autoFocus
            />
            {loadingLink && <SmallSpinner size={16} margin={0} />}
            {linkResults.length > 0 && (
              <div className="flex flex-col gap-1 max-h-40 overflow-y-auto">
                {linkResults.map((result) => (
                  <div
                    key={result.objectID}
                    className="flex flex-row justify-between items-center text-h5 px-2 py-1 bg-white rounded-md border-1 border-shadow_10 cursor-pointer hover:bg-amber-100"
                    onClick={() => handleLinkDevis(result)}
                  >
                    <span>{result.nom || "Sans nom"}</span>
                    <span className="text-shadow_50">{result.num || ""}</span>
                  </div>
                ))}
              </div>
            )}
            {linkSearchValue.length >= 2 && linkResults.length === 0 && !loadingLink && (
              <div className="text-h5 text-shadow_50">Aucun résultat</div>
            )}
          </div>
        )}
        {folderData.invoices?.map((invoice, index) => (
          <div
            key={index}
            className="bg-white px-1 py-1 flex flex-col   gap-1 rounded-md  text-h4 text-shadow_50 border-1 border-shadow_10"
          >
            <div className="flex flex-row gap-1 flex-wrap">
              {devis[index]?.state === "draft" && (
                <div className="text-h5 text-neutral-600 w-fit px-2 py-0.5 rounded-md border-neutral-300 border-1 bg-neutral-50">
                  Brouillon
                </div>
              )}
              {(devis[index]?.state === "wait" || devis[index]?.state === "locked") && (
                <div className="text-h5 text-orange-600 w-fit px-2 py-0.5 rounded-md border-orange-300 border-1 bg-orange-50">
                  En attente
                </div>
              )}
              {devis[index]?.state === "done" && (
                <div className="text-h5 text-green-600 w-fit px-2 py-0.5 rounded-md border-green-300 border-1 bg-green-50">
                  Signé
                </div>
              )}
              {devis[index]?.state === "cancelled" && (
                <div className="text-h5 text-red-600 w-fit px-2 py-0.5 rounded-md border-red-300 border-1 bg-red-50">
                  Annulé
                </div>
              )}
              {devis[index]?.pennylane?.devis_id && (
                <div className="text-h5 text-green-500 w-fit px-2 py-0.5 rounded-md border-green-200 border-1 bg-green-50">
                  Pennylane
                </div>
              )}
            </div>
            <div
              onClick={() => handleLoadInvoice(invoice)}
              className="hover:text-indigo-500 text-h5 py-1 px-2 border-1 rounded-md border-indigo-200 bg-indigo-50 w-full hover:underline cursor-pointer"
            >
              {invoice.file.name?.substring(0, 30)}
            </div>
            {loadingInvoice === invoice.file.id && (
              <SmallSpinner></SmallSpinner>
            )}
            {isFolderAdmin(orgData, folderData) && (
              <div className="flex flex-row items-center w-full">
                <div
                  className="cursor-pointer hover:text-red-500  ml-auto "
                  onClick={() => handleRemoveInvoice(invoice)}
                >
                  <Icon1
                    icon_name="delete"
                    fill="grey"
                    hover_color={"red"}
                    size={16}
                  ></Icon1>
                </div>
                {invoice?.ref && (
                  <div
                    className="
                    hover:shadow-xl hover:scale-105
                    w-fit cursor-pointer bg-white border ml-2 rounded-md px-2 py-1  "
                    onClick={() => {
                      navigateWorkspace("/invoice/" + invoice?.ref.id);
                    }}
                  >
                    <Icon1 icon_name="open" size={16}></Icon1>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
        {isFolderAdmin(orgData, folderData) && (
          <>
            {dropped_exists && (
              <PrimaryButton
                className="h-full w-fit animate-shimmer rounded-2xl "
                onClick={() => handleTransferFiles("devis")}
                disabled={
                  loadingTransfer !== undefined && loadingTransfer !== null
                }
              >
                <div>
                  <div className="flex flex-row gap-1 items-center">
                    {loadingTransfer === "devis"
                      ? "Transfert en cours ..."
                      : "Transférer ici"}
                    <SmallSpinner
                      loading={loadingTransfer === "devis"}
                      margin={0}
                      size={20}
                    />
                  </div>
                </div>
              </PrimaryButton>
            )}
          </>
        )}
      </div>
      {!folderData.invoices && (
        <div className="flex flex-row gap-2 text-h3 text-shadow_50 my-1">
          <Icon1 icon_name="linked_file" size={20} fill={"grey"}></Icon1>
          Pas de devis associé
        </div>
      )}
    </div>
  );
};

export default ReglementFolderDevis;
